module.exports = __webpack_public_path__ + "img/lv.99856737.png";